require('./bootstrap');
require('waypoints/lib/noframework.waypoints.js');
window.Vue = require('vue');
require('./global');

// Vue JS App
require('./filters/currency');


import header from './components/navigation';

import swiper from './components/swiper';
$('.swiper-component').each((index, el) => {
    swiper.init(el);
}) ;


import videoPopup from './components/video-popup';
$('.component-video-popup').each((index, el) => {
    videoPopup.init(el);
});


import gallery from './components/gallery';
$('.component--gallery').each((index, el) => {
    gallery.init(el);
}) ;


import Notification from './components/Notification';

if ($('#notification').length ) {
    new Vue({
        el: '#notification',
        components: {
            Notification
        }
    })
}


import VideoPlayer from './components/Video';
$('.video-component').each((index, el) => {
    new Vue({
        el: el,
        components: {
            VideoPlayer
        }
    })
});



$('.component').each(function() {
    new Waypoint({
        element: this,
        offset: '80%',
        handler: function(direction) {
            $(this.element).addClass('component--active');
        }
    });
});


import PriceGuide from "./components/PriceGuide";
$('#price-guide').each((index, el) => {
    new Vue({
        el: el,
        components: {
            PriceGuide
        }
    })
})



var Instafeed = require("instafeed.js");

var feed = new Instafeed({
    get: 'user',
    userId:  window.userID,
    accessToken: window.accessToken,
    resolution: 'low_resolution',
    limit: 6,
    template: '<div class="instafeed-entry" style="background-image: url({{image}})"><div></div></div>'
});
feed.run();

function resizeFooter() {
    let height = $('footer.footer').outerHeight();
    $('.footer-instagram').css('marginBottom', height - 5 + 'px');
}

resizeFooter();

window.onresize = resizeFooter;